import apiClient from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Fetches the parent company list from the API.
 * API response shape: { result: [{ parentCode, parentName }, ...] }
 * Returns: { success: true, data: [{ parentCode, parentName }] } | { success: false, message }
 */
export const fetchParentListAction = async () => {
  try {
    const response = await apiClient.get(ATP_API_URL.PARENT_LIST);

    if (response?.status === 200) {
      // unwrap: response.data = { result: [...] }
      const raw =
        response.data?.result ?? response.data?.data ?? response.data ?? [];
      const data = Array.isArray(raw) ? raw : [];
      console.log("[fetchParentListAction] Parent list:", data);
      return { success: true, data };
    }

    return { success: false, message: "Failed to fetch parent list", data: [] };
  } catch (error) {
    console.error("[fetchParentListAction] Error:", error);
    return {
      success: false,
      message: error.message || "Failed to fetch parent list",
      data: [],
    };
  }
};
